import { LocationVerificationPillVisual } from './login-geo-types.types';
import { useStore } from '@/store/store';

/** Match Android `LOGIN_LOCATION_PILL_DISMISS_MS` (MainActivityViewModel). */
const PILL_DISMISS_MS = 1_000;

const shouldShowLoginGeoPill = (): boolean => !useStore.getState().embeddedGame.isOpen;

let snapshot: LocationVerificationPillVisual | null = null;
let heartbeatSeq = 0;
const listeners = new Set<() => void>();
let dismissTimer: ReturnType<typeof setTimeout> | null = null;

const emit = () => {
    listeners.forEach((l) => l());
};

export const getLoginGeoPillSnapshot = (): LocationVerificationPillVisual | null => snapshot;

export const getLoginGeoPillHeartbeatSeq = (): number => heartbeatSeq;

export const pulseLoginGeoPillHeartbeat = (): void => {
    if (!shouldShowLoginGeoPill() || snapshot !== LocationVerificationPillVisual.VERIFYING) {
        return;
    }
    heartbeatSeq += 1;
    emit();
};

export const subscribeLoginGeoPill = (onStoreChange: () => void): (() => void) => {
    listeners.add(onStoreChange);
    return () => {
        listeners.delete(onStoreChange);
    };
};

export const setLoginGeoPill = (visual: LocationVerificationPillVisual): void => {
    if (!shouldShowLoginGeoPill()) {
        return;
    }
    if (dismissTimer) {
        clearTimeout(dismissTimer);
        dismissTimer = null;
    }
    snapshot = visual;
    emit();
};

export const setLoginGeoPillTransientResult = (visual: LocationVerificationPillVisual): void => {
    if (!shouldShowLoginGeoPill()) {
        return;
    }
    if (dismissTimer) {
        clearTimeout(dismissTimer);
        dismissTimer = null;
    }
    snapshot = visual;
    emit();
    dismissTimer = setTimeout(() => {
        dismissTimer = null;
        snapshot = null;
        emit();
    }, PILL_DISMISS_MS);
};

export const clearLoginGeoPill = (): void => {
    if (dismissTimer) {
        clearTimeout(dismissTimer);
        dismissTimer = null;
    }
    snapshot = null;
    heartbeatSeq = 0;
    emit();
};
